import React from 'react';
import classNames from 'classnames';

import css from './BrandIconCard.module.css';

const INSTAGRAM = 'instagram';
const FACEBOOK = 'facebook';
const SLICKLEFT = 'slickleft';
const SLICKRIGHT = 'slickright';
const CROSS = 'cross';
const CHECKBADGE = 'checkbadge';
const FILLSTAR = 'fillstar';
const DOWNARROW = 'downarrow';
const UPARROW = 'uparrow';
const NIGHTLIFE = 'nightlife';
const ART = 'art';
const DINING = 'dining';
const SHOPPING = 'shopping';
const PERFORMINGART = 'performingart';
const WELLNESS = 'wellness';
const DELETE = 'delete';
const EDIT = 'edit';
const BLACKBADGE = 'blackbadge';
const NEXT = 'next';
const PREVIOUS = 'previous';
const CALENDER = 'calender';

/**
 * Payment card icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {'amex' | 'diners' | 'discovery' | 'jcb' | 'mastercard' | 'unionpay' | 'visa'} props.type payment card provider
 * @returns {JSX.Element} SVG icon
 */
const BrandIconCard = props => {
  const { className, rootClassName, type = 'default' } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (type) {
    case CALENDER:
      return (
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.20801 2.16667C9.20801 1.86751 8.9655 1.625 8.66634 1.625C8.36719 1.625 8.12467 1.86751 8.12467 2.16667V3.79167H5.41634C3.92057 3.79167 2.70801 5.00423 2.70801 6.5V21.6667C2.70801 23.1624 3.92057 24.375 5.41634 24.375H20.583C22.0788 24.375 23.2913 23.1624 23.2913 21.6667V6.5C23.2913 5.00423 22.0788 3.79167 20.583 3.79167H17.8747V2.16667C17.8747 1.86751 17.6322 1.625 17.333 1.625C17.0339 1.625 16.7913 1.86751 16.7913 2.16667V3.79167H9.20801V2.16667ZM22.208 10.2917V6.5C22.208 5.60254 21.4805 4.875 20.583 4.875H17.8747V6.5C17.8747 6.79915 17.6322 7.04167 17.333 7.04167C17.0339 7.04167 16.7913 6.79915 16.7913 6.5V4.875H9.20801V6.5C9.20801 6.79915 8.9655 7.04167 8.66634 7.04167C8.36719 7.04167 8.12467 6.79915 8.12467 6.5V4.875H5.41634C4.51888 4.875 3.79134 5.60254 3.79134 6.5V10.2917H22.208ZM3.79134 11.375H22.208V21.6667C22.208 22.5641 21.4805 23.2917 20.583 23.2917H5.41634C4.51888 23.2917 3.79134 22.5641 3.79134 21.6667V11.375Z"
            fill="#1A1B2F"
            stroke="#1A1B2F"
            strokeWidth="0.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case PREVIOUS:
      return (
        <svg
          fill="#d4af37"
          width="40px"
          height="40px"
          viewBox="-3.925 0 25.6 25.6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m12.85 3.2 1.7 1.7 -8.15 8.2 8.15 8.2 -1.7 1.7L3.05 13.1z" />
        </svg>
      );
    case NEXT:
      return (
        <svg
          fill="#d4af37"
          width="50px"
          height="50px"
          viewBox="-4.813 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m6.125 28.75 -2.125 -2.125 10.188 -10.25L4 6.125l2.125 -2.125 12.25 12.375z" />
        </svg>
      );
    case EDIT:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.9831 2L22 8.01692L8.01692 22L2.00566 21.9943L2 15.9831L15.9831 2ZM3.5149 16.6097L3.51855 20.4815L7.39026 20.4851L19.8584 8.01692L15.9831 4.14156L3.5149 16.6097Z"
            fill="#1A1B2F"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.00525 20.4795L21.0021 20.4801L21.0021 21.9944L2.00566 21.9943L2.00525 20.4795Z"
            fill="#1A1B2F"
          />
        </svg>
      );
    case DELETE:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.2486 5.5463C20.2741 5.13287 19.9597 4.777 19.5463 4.75143C19.1329 4.72586 18.777 5.04028 18.7514 5.4537L20.2486 5.5463ZM18.88 15.525L18.1314 15.4787L18.1314 15.4788L18.88 15.525ZM18 20.288L17.385 19.8587L17.3848 19.859L18 20.288ZM16.8 21.416L16.4098 20.7755L16.4093 20.7758L16.8 21.416ZM7.18 21.415L6.78937 22.0552L6.78943 22.0553L7.18 21.415ZM5.98 20.285L6.59563 19.8566L6.59549 19.8564L5.98 20.285ZM5.106 15.515L5.85465 15.4701L5.85463 15.4697L5.106 15.515ZM5.24863 5.4547C5.22361 5.04124 4.86816 4.72635 4.4547 4.75137C4.04124 4.77639 3.72635 5.13184 3.75137 5.5453L5.24863 5.4547ZM3 4.75H2.25V6.25H3V4.75ZM21 6.25H21.75V4.75H21V6.25ZM15.3812 5.82733C15.562 6.20002 16.0107 6.35558 16.3833 6.1748C16.756 5.99402 16.9116 5.54535 16.7308 5.17267L15.3812 5.82733ZM15.373 4.092L14.6979 4.41873L14.6982 4.41933L15.373 4.092ZM14.302 2.397L14.7508 1.79608L14.75 1.79548L14.302 2.397ZM14.027 2.225L13.6812 2.89051L13.6822 2.89102L14.027 2.225ZM9.995 2.234L9.64346 1.57148L9.6409 1.57286L9.995 2.234ZM9.717 2.414L10.1735 3.00909L10.1754 3.00764L9.717 2.414ZM8.659 4.171L7.97664 3.85975L7.9766 3.85984L8.659 4.171ZM7.3706 5.18884C7.19874 5.56572 7.36495 6.01055 7.74184 6.1824C8.11872 6.35426 8.56355 6.18805 8.73541 5.81116L7.3706 5.18884ZM8.75 16.5C8.75 16.9142 9.08579 17.25 9.5 17.25C9.91421 17.25 10.25 16.9142 10.25 16.5H8.75ZM10.25 10.5C10.25 10.0858 9.91421 9.75 9.5 9.75C9.08579 9.75 8.75 10.0858 8.75 10.5H10.25ZM13.75 16.5C13.75 16.9142 14.0858 17.25 14.5 17.25C14.9142 17.25 15.25 16.9142 15.25 16.5H13.75ZM15.25 10.5C15.25 10.0858 14.9142 9.75 14.5 9.75C14.0858 9.75 13.75 10.0858 13.75 10.5H15.25ZM19.5 5.5L18.7514 5.4537L18.1314 15.4787L18.88 15.525L19.6286 15.5713L20.2486 5.5463L19.5 5.5ZM18.88 15.525L18.1314 15.4788C18.0515 16.7739 17.9941 17.6923 17.8811 18.404C17.7701 19.1036 17.6154 19.5288 17.385 19.8587L18 20.288L18.615 20.7173C19.0276 20.1262 19.2339 19.4504 19.3626 18.639C19.4894 17.8397 19.5505 16.8371 19.6286 15.5712L18.88 15.525ZM18 20.288L17.3848 19.859C17.1269 20.2288 16.7949 20.5409 16.4098 20.7755L16.8 21.416L17.1902 22.0565C17.753 21.7137 18.2382 21.2575 18.6152 20.717L18 20.288ZM16.8 21.416L16.4093 20.7758C16.0669 20.9847 15.6337 21.1128 14.9288 21.1804C14.2117 21.2492 13.2916 21.25 11.994 21.25V22V22.75C13.2624 22.75 14.2668 22.7508 15.072 22.6736C15.8893 22.5952 16.5761 22.4313 17.1907 22.0562L16.8 21.416ZM11.994 22V21.25C10.6944 21.25 9.77276 21.2492 9.05448 21.1803C8.34831 21.1126 7.91404 20.9842 7.57057 20.7747L7.18 21.415L6.78943 22.0553C7.40496 22.4308 8.09269 22.5949 8.91127 22.6734C9.71774 22.7508 10.7236 22.75 11.994 22.75V22ZM7.18 21.415L7.57063 20.7748C7.18542 20.5397 6.85337 20.227 6.59563 19.8566L5.98 20.285L5.36437 20.7134C5.74106 21.2547 6.22636 21.7117 6.78937 22.0552L7.18 21.415ZM5.98 20.285L6.59549 19.8564C6.36553 19.5262 6.2111 19.1003 6.10089 18.3996C5.9888 17.6869 5.93252 16.767 5.85465 15.4701L5.106 15.515L4.35735 15.5599C4.43348 16.828 4.4932 17.8321 4.61911 18.6327C4.7469 19.4452 4.95247 20.1218 5.36451 20.7136L5.98 20.285ZM5.106 15.515L5.85463 15.4697L5.24863 5.4547L4.5 5.5L3.75137 5.5453L4.35737 15.5603L5.106 15.515ZM3 5.5V6.25H21V5.5V4.75H3V5.5ZM16.056 5.5L16.7308 5.17267L16.0478 3.76467L15.373 4.092L14.6982 4.41933L15.3812 5.82733L16.056 5.5ZM15.373 4.092L16.0481 3.76527C15.8272 3.30887 15.6409 2.92276 15.4573 2.61695C15.2664 2.29912 15.0521 2.02113 14.7508 1.79608L14.302 2.397L13.8532 2.99792C13.9429 3.06487 14.0376 3.16638 14.1712 3.38905C14.3121 3.62374 14.4658 3.93913 14.6979 4.41873L15.373 4.092ZM14.302 2.397L14.75 1.79548C14.6305 1.70654 14.5041 1.62744 14.3718 1.55898L14.027 2.225L13.6822 2.89102C13.7423 2.92214 13.7998 2.9581 13.854 2.99852L14.302 2.397ZM14.027 2.225L14.3728 1.55949C14.0385 1.38576 13.6943 1.31418 13.3252 1.28112C12.97 1.24931 12.5413 1.25 12.035 1.25V2V2.75C12.5677 2.75 12.9185 2.75069 13.1913 2.77513C13.4502 2.79832 13.5825 2.83924 13.6812 2.89051L14.027 2.225ZM12.035 2V1.25C11.5155 1.25 11.0761 1.24929 10.7127 1.28233C10.3351 1.31667 9.98356 1.39103 9.64346 1.57149L9.995 2.234L10.3465 2.89651C10.4474 2.84297 10.5829 2.80033 10.8486 2.77617C11.1284 2.75071 11.4885 2.75 12.035 2.75V2ZM9.995 2.234L9.6409 1.57286C9.50686 1.64465 9.379 1.72743 9.25865 1.82036L9.717 2.414L10.1754 3.00764C10.2301 2.96541 10.2882 2.92778 10.3491 2.89514L9.995 2.234ZM9.717 2.414L9.26052 1.81892C8.95518 2.05314 8.7418 2.34223 8.55417 2.67112C8.37356 2.98772 8.19202 3.38756 7.97664 3.85975L8.659 4.171L9.34136 4.48225C9.56798 3.98544 9.71794 3.65828 9.85708 3.41438C9.9892 3.18277 10.0838 3.07786 10.1735 3.00908L9.717 2.414ZM8.659 4.171L7.9766 3.85984L7.3706 5.18884L8.053 5.5L8.73541 5.81116L9.34141 4.48216L8.659 4.171ZM9.5 16.5H10.25V10.5H9.5H8.75V16.5H9.5ZM14.5 16.5H15.25V10.5H14.5H13.75V16.5H14.5Z"
            fill="#1A1B2F"
          />
        </svg>
      );
    case BLACKBADGE:
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#1A1B2F" />
          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#F4F4F4" />
          <path
            d="M21.8263 21.8327H21.8346H21.8263ZM21.8263 21.8327C21.308 22.3468 20.368 22.2193 19.708 22.2193C18.898 22.2193 18.508 22.3777 17.9305 22.9552C17.4388 23.4468 16.7796 24.3327 16.0013 24.3327C15.223 24.3327 14.5638 23.4468 14.0721 22.9552C13.4938 22.3777 13.1038 22.2193 12.2946 22.2193C11.6355 22.2193 10.6946 22.3477 10.1755 21.8327C9.65297 21.3143 9.7813 20.3693 9.7813 19.706C9.7813 18.8668 9.59797 18.481 9.00047 17.8843C8.11214 16.996 7.66797 16.551 7.66797 15.9993C7.66797 15.4477 8.11214 15.0027 9.0013 14.1143C9.53464 13.581 9.7813 13.0527 9.7813 12.2927C9.7813 11.6335 9.65297 10.6927 10.168 10.1735C10.6863 9.65102 11.6313 9.77935 12.2946 9.77935C13.0546 9.77935 13.583 9.53185 14.1163 8.99852C15.0046 8.11018 15.4496 7.66602 16.0013 7.66602C16.553 7.66602 16.998 8.11018 17.8863 8.99935C18.4196 9.53268 18.948 9.77935 19.708 9.77935C20.3671 9.77935 21.308 9.65102 21.8271 10.166C22.3496 10.6843 22.2213 11.6293 22.2213 12.2927C22.2213 13.1318 22.4046 13.5177 23.0021 14.1143C23.8905 15.0027 24.3346 15.4477 24.3346 15.9993C24.3346 16.551 23.8905 16.996 23.0013 17.8843C22.4046 18.4818 22.2213 18.8677 22.2213 19.706C22.2213 20.3693 22.3488 21.3143 21.8263 21.8327Z"
            fill="white"
          />
          <path
            d="M13.5 16.7435C13.5 16.7435 14.5 17.2868 15 18.0827C15 18.0827 16.5 14.9577 18.5 13.916"
            fill="white"
          />
          <path
            d="M13.5 16.7435C13.5 16.7435 14.5 17.2868 15 18.0827C15 18.0827 16.5 14.9577 18.5 13.916"
            stroke="#1A1B2F"
            strokeLinecap="round"
            fill="none"
            strokeLinejoin="round"
          />
        </svg>
      );
    case WELLNESS:
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 29.1667C20.0133 29.1667 20.0267 29.167 20.04 29.1676L20 29.1667Z"
            fill="#D4AF37"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5893 2.74408C20.2638 2.41864 19.7362 2.41864 19.4107 2.74408L7.74408 14.4107C5.25642 16.8984 2.5 19.9536 2.5 24.1667C2.5 25.4799 2.75866 26.7802 3.2612 27.9935C3.76375 29.2068 4.50035 30.3091 5.42893 31.2377C7.3043 33.1131 9.84783 34.1667 12.5 34.1667C14.0815 34.1667 15.4521 33.9463 16.7722 33.3673C17.596 33.006 18.3785 32.5145 19.1667 31.8791V36.6667C19.1667 37.1269 19.5398 37.5 20 37.5C20.4602 37.5 20.8333 37.1269 20.8333 36.6667V31.8791C21.6215 32.5145 22.404 33.006 23.2278 33.3673C24.5479 33.9463 25.9185 34.1667 27.5 34.1667C28.8132 34.1667 30.1136 33.908 31.3268 33.4055C32.5401 32.9029 33.6425 32.1663 34.5711 31.2377C35.4997 30.3091 36.2362 29.2068 36.7388 27.9935C37.2413 26.7802 37.5 25.4799 37.5 24.1667C37.5 19.9536 34.7436 16.8984 32.2559 14.4107L20.5893 2.74408ZM20.04 29.1676C20.2397 29.1772 20.4367 29.2582 20.5893 29.4107C21.795 30.6165 22.8361 31.3756 23.8972 31.841C24.9521 32.3037 26.0815 32.5 27.5 32.5C28.5943 32.5 29.678 32.2845 30.689 31.8657C31.7001 31.4469 32.6187 30.833 33.3926 30.0592C34.1664 29.2854 34.7802 28.3667 35.199 27.3557C35.6178 26.3446 35.8333 25.261 35.8333 24.1667C35.8333 20.7131 33.5898 18.1016 31.0774 15.5893L20 4.51185L8.92259 15.5893C6.41024 18.1016 4.16667 20.7131 4.16667 24.1667C4.16667 25.261 4.38221 26.3446 4.801 27.3557C5.21979 28.3667 5.83362 29.2854 6.60744 30.0592C8.17025 31.622 10.2899 32.5 12.5 32.5C13.9185 32.5 15.0479 32.3037 16.1028 31.841C17.1639 31.3756 18.205 30.6165 19.4107 29.4107C19.4906 29.3308 19.5827 29.2706 19.681 29.2299C19.777 29.1901 19.8821 29.1677 19.9923 29.1667"
            fill="#D4AF37"
          />
        </svg>
      );
    case PERFORMINGART:
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.16667 18.332C9.16667 17.8718 9.53976 17.4987 10 17.4987C11.3202 17.4987 12.7307 17.7152 13.8422 18.3327C15.0038 18.9781 15.8333 20.0691 15.8333 21.6654C15.8333 22.1256 15.4602 22.4987 15 22.4987H14.9737C14.1611 22.4987 13.403 22.4987 12.7433 22.4437C12.0793 22.3884 11.4344 22.2726 10.8773 21.9941C10.2902 21.7005 9.83892 21.2454 9.55099 20.5976C9.27593 19.9787 9.16667 19.2223 9.16667 18.332ZM10.8865 19.2053C10.9293 19.5107 10.995 19.7429 11.074 19.9207C11.2027 20.2103 11.3764 20.3802 11.6227 20.5033C11.899 20.6415 12.2957 20.734 12.8817 20.7828C13.2206 20.8111 13.596 20.8231 14.0166 20.8282C13.8352 20.3795 13.4957 20.0468 13.0328 19.7897C12.4653 19.4744 11.7176 19.2828 10.8865 19.2053Z"
            fill="#D4AF37"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 17.4987C28.6798 17.4987 27.2693 17.7152 26.1578 18.3327C24.9962 18.9781 24.1667 20.0691 24.1667 21.6654C24.1667 22.1256 24.5398 22.4987 25 22.4987H25.0263C25.8389 22.4987 26.597 22.4987 27.2567 22.4437C27.9207 22.3884 28.5656 22.2726 29.1227 21.9941C29.7098 21.7005 30.1611 21.2454 30.449 20.5976C30.7241 19.9787 30.8333 19.2223 30.8333 18.332C30.8333 17.8718 30.4602 17.4987 30 17.4987ZM27.1183 20.7828C26.7794 20.8111 26.404 20.8231 25.9834 20.8282C26.1648 20.3795 26.5043 20.0468 26.9672 19.7897C27.5347 19.4744 28.2824 19.2829 29.1135 19.2053C29.0707 19.5107 29.005 19.7429 28.926 19.9207C28.7973 20.2103 28.6236 20.3802 28.3773 20.5033C28.101 20.6415 27.7043 20.734 27.1183 20.7828Z"
            fill="#D4AF37"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.5 11.6654C2.5 11.2051 2.8731 10.832 3.33333 10.832H11.6667C11.677 10.832 11.6874 10.8322 11.6977 10.8326C14.7291 10.9455 17.6376 12.0281 20 13.911C22.3624 12.0281 25.2709 10.9455 28.3023 10.8326C28.3126 10.8322 28.323 10.832 28.3333 10.832H36.6667C37.1269 10.832 37.5 11.2051 37.5 11.6654V19.9987C37.5 22.4298 36.5342 24.7614 34.8151 26.4805C33.0999 28.1958 30.7748 29.1611 28.3495 29.1654C25.4678 29.2761 22.7129 30.3799 20.5519 32.2898C20.2367 32.5683 19.7633 32.5683 19.4481 32.2898C17.2871 30.3799 14.5322 29.2761 11.6505 29.1654C9.22517 29.1611 6.90012 28.1958 5.18485 26.4805C3.46577 24.7614 2.5 22.4298 2.5 19.9987V11.6654ZM4.16667 12.4987V19.9987C4.16667 21.9878 4.95684 23.8955 6.36337 25.302C7.76989 26.7085 9.67754 27.4987 11.6667 27.4987C11.677 27.4987 11.6874 27.4989 11.6977 27.4993C14.7291 27.6122 17.6376 28.6947 20 30.5777C22.3624 28.6947 25.2709 27.6122 28.3023 27.4993C28.3126 27.4989 28.323 27.4987 28.3333 27.4987C30.3225 27.4987 32.2301 26.7085 33.6366 25.302C35.0432 23.8955 35.8333 21.9878 35.8333 19.9987V12.4987H28.3491C25.4676 12.6096 22.7128 13.7133 20.5519 15.6231C20.2367 15.9017 19.7633 15.9017 19.4481 15.6231C17.2872 13.7133 14.5324 12.6096 11.6509 12.4987H4.16667Z"
            fill="#D4AF37"
          />
        </svg>
      );
    case SHOPPING:
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.1667 16.6667C14.1667 16.2064 13.7936 15.8333 13.3333 15.8333C12.8731 15.8333 12.5 16.2064 12.5 16.6667C12.5 18.6558 13.2902 20.5634 14.6967 21.97C16.1032 23.3765 18.0109 24.1667 20 24.1667C21.9891 24.1667 23.8968 23.3765 25.3033 21.97C26.7098 20.5634 27.5 18.6558 27.5 16.6667C27.5 16.2064 27.1269 15.8333 26.6667 15.8333C26.2064 15.8333 25.8333 16.2064 25.8333 16.6667C25.8333 18.2138 25.2188 19.6975 24.1248 20.7915C23.0308 21.8854 21.5471 22.5 20 22.5C18.4529 22.5 16.9692 21.8854 15.8752 20.7915C14.7812 19.6975 14.1667 18.2138 14.1667 16.6667Z"
            fill="#D4AF37"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.33333 2.83333C9.49071 2.6235 9.7377 2.5 10 2.5H30C30.2623 2.5 30.5093 2.6235 30.6667 2.83333L35.6616 9.49324C35.7602 9.62173 35.8221 9.77975 35.8319 9.95174C35.8329 9.96777 35.8333 9.98387 35.8333 10V33.3333C35.8333 34.4384 35.3943 35.4982 34.6129 36.2796C33.8315 37.061 32.7717 37.5 31.6667 37.5H8.33333C7.22826 37.5 6.16845 37.061 5.38705 36.2796C4.60565 35.4982 4.16666 34.4384 4.16666 33.3333V10C4.16666 9.80937 4.23068 9.63368 4.33838 9.49327L9.33333 2.83333ZM29.5833 4.16667L33.3333 9.16667H6.66666L10.4167 4.16667H29.5833ZM5.83333 33.3333V10.8333H34.1667V33.3333C34.1667 33.9964 33.9033 34.6323 33.4344 35.1011C32.9656 35.5699 32.3297 35.8333 31.6667 35.8333H8.33333C7.67029 35.8333 7.0344 35.5699 6.56556 35.1011C6.09672 34.6323 5.83333 33.9964 5.83333 33.3333Z"
            fill="#D4AF37"
          />
        </svg>
      );
    case DINING:
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 2.5C5.46023 2.5 5.83333 2.8731 5.83333 3.33333V15C5.83333 16.3731 6.96023 17.5 8.33333 17.5H10.8333V3.33333C10.8333 2.8731 11.2064 2.5 11.6667 2.5C12.1269 2.5 12.5 2.8731 12.5 3.33333V17.5H15C15.663 17.5 16.2989 17.2366 16.7678 16.7678C17.2366 16.2989 17.5 15.663 17.5 15V3.33333C17.5 2.8731 17.8731 2.5 18.3333 2.5C18.7936 2.5 19.1667 2.8731 19.1667 3.33333V15C19.1667 16.1051 18.7277 17.1649 17.9463 17.9463C17.1649 18.7277 16.1051 19.1667 15 19.1667H12.5V36.6667C12.5 37.1269 12.1269 37.5 11.6667 37.5C11.2064 37.5 10.8333 37.1269 10.8333 36.6667V19.1667H8.33333C6.03976 19.1667 4.16666 17.2936 4.16666 15V3.33333C4.16666 2.8731 4.53976 2.5 5 2.5Z"
            fill="#D4AF37"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35 2.5C32.5688 2.5 30.2373 3.46577 28.5182 5.18485C26.7991 6.90394 25.8333 9.23552 25.8333 11.6667V21.6667C25.8333 23.9602 27.7064 25.8333 30 25.8333H34.1667V36.6667C34.1667 37.1269 34.5398 37.5 35 37.5C35.4602 37.5 35.8333 37.1269 35.8333 36.6667V3.33333C35.8333 3.11232 35.7455 2.90036 35.5893 2.74408C35.433 2.5878 35.221 2.5 35 2.5ZM34.1667 4.21308V24.1667H30C28.6269 24.1667 27.5 23.0398 27.5 21.6667V11.6667C27.5 9.67754 28.2902 7.76989 29.6967 6.36337C30.9054 5.15468 32.4841 4.40114 34.1667 4.21308Z"
            fill="#D4AF37"
          />
        </svg>
      );
    case ART:
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.8333 10.8333C20.8333 9.91286 21.5795 9.16667 22.5 9.16667C23.4205 9.16667 24.1667 9.91286 24.1667 10.8333C24.1667 11.7538 23.4205 12.5 22.5 12.5C21.5795 12.5 20.8333 11.7538 20.8333 10.8333Z"
            fill="#D4AF37"
          />
          <path
            d="M27.5 17.5C27.5 16.5795 28.2462 15.8333 29.1667 15.8333C30.0871 15.8333 30.8333 16.5795 30.8333 17.5C30.8333 18.4205 30.0871 19.1667 29.1667 19.1667C28.2462 19.1667 27.5 18.4205 27.5 17.5Z"
            fill="#D4AF37"
          />
          <path
            d="M14.1667 10.8333C13.2462 10.8333 12.5 11.5795 12.5 12.5C12.5 13.4205 13.2462 14.1667 14.1667 14.1667C15.0871 14.1667 15.8333 13.4205 15.8333 12.5C15.8333 11.5795 15.0871 10.8333 14.1667 10.8333Z"
            fill="#D4AF37"
          />
          <path
            d="M9.16667 20.8333C9.16667 19.9129 9.91286 19.1667 10.8333 19.1667C11.7538 19.1667 12.5 19.9129 12.5 20.8333C12.5 21.7538 11.7538 22.5 10.8333 22.5C9.91286 22.5 9.16667 21.7538 9.16667 20.8333Z"
            fill="#D4AF37"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 2.5C10.3731 2.5 2.5 10.3731 2.5 20C2.5 29.6269 10.3731 37.5 20 37.5C22.0244 37.5 23.58 35.8625 23.58 33.8533C23.58 32.8956 23.1873 32.0409 22.642 31.4256C22.6306 31.4127 22.6188 31.4002 22.6066 31.3881C22.2955 31.078 22.1217 30.6928 22.1217 30.1033L22.1215 30.089C22.1171 29.834 22.1641 29.5807 22.2597 29.3443C22.3553 29.1079 22.4974 28.8931 22.6778 28.7128C22.8581 28.5324 23.0729 28.3903 23.3093 28.2947C23.5457 28.1991 23.799 28.1521 24.054 28.1565L24.0683 28.1567H27.395C32.94 28.1567 37.4867 23.6121 37.4867 18.0667L37.4867 18.062C37.4386 9.46986 29.4678 2.5 20 2.5ZM4.16667 20C4.16667 11.2936 11.2936 4.16667 20 4.16667C28.7346 4.16667 35.7766 10.5688 35.82 18.069C35.8187 22.6925 32.0192 26.49 27.395 26.49H24.075C23.5989 26.4828 23.1262 26.571 22.6848 26.7495C22.2409 26.9288 21.8378 27.1957 21.4992 27.5342C21.1607 27.8728 20.8938 28.2759 20.7145 28.7198C20.536 29.1614 20.4478 29.6342 20.455 30.1104C20.4565 31.0839 20.7693 31.8992 21.4092 32.5476C21.7125 32.8971 21.9133 33.3622 21.9133 33.8533C21.9133 34.9842 21.0623 35.8333 20 35.8333C11.2936 35.8333 4.16667 28.7064 4.16667 20Z"
            fill="#D4AF37"
          />
        </svg>
      );
    case NIGHTLIFE:
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 2.5C14.6526 2.5 14.3417 2.71548 14.2197 3.04073C11.7153 9.71912 10.8333 13.1728 10.8333 16.6667C10.8333 19.0978 11.7991 21.4294 13.5182 23.1485C15.0397 24.67 17.0411 25.6014 19.1667 25.7954V35.8333H13.3333C12.8731 35.8333 12.5 36.2064 12.5 36.6667C12.5 37.1269 12.8731 37.5 13.3333 37.5H26.6667C27.1269 37.5 27.5 37.1269 27.5 36.6667C27.5 36.2064 27.1269 35.8333 26.6667 35.8333H20.8333V25.7954C22.9589 25.6014 24.9603 24.67 26.4818 23.1485C28.2009 21.4294 29.1667 19.0978 29.1667 16.6667C29.1667 13.1728 28.2847 9.71912 25.7803 3.04073C25.6583 2.71548 25.3474 2.5 25 2.5H15ZM27.4815 15.8333C27.3541 12.9953 26.5483 9.89323 24.4215 4.16667H15.5785C13.4517 9.89323 12.6459 12.9953 12.5185 15.8333H27.4815ZM12.5464 17.5H27.4536C27.2655 19.1825 26.512 20.7613 25.3033 21.97C23.8968 23.3765 21.9891 24.1667 20 24.1667C18.0109 24.1667 16.1032 23.3765 14.6967 21.97C13.488 20.7613 12.7345 19.1825 12.5464 17.5Z"
            fill="#D4AF37"
          />
        </svg>
      );
    case UPARROW:
      return (
        <svg
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.03361 1.30956C6.56614 0.777023 7.42955 0.777023 7.96208 1.30956L13.4158 6.76327L12.4524 7.72834L11.4881 8.69252L6.99784 4.20227L2.50836 8.69175L1.5433 7.72834L0.579113 6.76405L6.03361 1.30956ZM1.5433 7.72834L0.579113 6.76405C0.0465802 7.29658 0.0465282 8.16004 0.579061 8.69257C1.11159 9.22511 1.97583 9.22428 2.50836 8.69175L1.5433 7.72834ZM13.4166 8.69257C12.8841 9.22511 12.0206 9.22506 11.4881 8.69252L12.4524 7.72834L13.4158 6.76327C13.9483 7.29581 13.9492 8.16004 13.4166 8.69257Z"
            fill="#1A1B2F"
          />
        </svg>
      );
    case DOWNARROW:
      return (
        <svg
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.03361 8.69044C6.56614 9.22298 7.42955 9.22298 7.96208 8.69044L13.4158 3.23673L12.4524 2.27166L11.4881 1.30748L6.99784 5.79773L2.50836 1.30825L1.5433 2.27166L0.579113 3.23595L6.03361 8.69044ZM1.5433 2.27166L0.579113 3.23595C0.0465802 2.70342 0.0465282 1.83996 0.579061 1.30743C1.11159 0.774892 1.97583 0.775721 2.50836 1.30825L1.5433 2.27166ZM13.4166 1.30743C12.8841 0.774892 12.0206 0.774944 11.4881 1.30748L12.4524 2.27166L13.4158 3.23673C13.9483 2.70419 13.9492 1.83996 13.4166 1.30743Z"
            fill="#1A1B2F"
          />
        </svg>
      );
    case FILLSTAR:
      return (
        <svg
          width="18"
          height="17"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.00032 14.2698L13.1503 16.7798C13.9103 17.2398 14.8403 16.5598 14.6403 15.6998L13.5403 10.9798L17.2103 7.79977C17.8803 7.21977 17.5203 6.11977 16.6403 6.04977L11.8103 5.63977L9.92032 1.17977C9.58032 0.369766 8.42032 0.369766 8.08032 1.17977L6.19032 5.62977L1.36032 6.03977C0.480317 6.10977 0.120317 7.20977 0.790317 7.78977L4.46032 10.9698L3.36032 15.6898C3.16032 16.5498 4.09032 17.2298 4.85032 16.7698L9.00032 14.2698Z"
            fill="#D4AF37"
          />
        </svg>
      );
    case CHECKBADGE:
      return (
        <svg
          fill="#D4AF37"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="#D4AF37" />
          <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#F4F4F4" />
          <path
            d="M16.6597 16.6663H16.6663H16.6597ZM16.6597 16.6663C16.245 17.0777 15.493 16.9757 14.965 16.9757C14.317 16.9757 14.005 17.1023 13.543 17.5643C13.1497 17.9577 12.6223 18.6663 11.9997 18.6663C11.377 18.6663 10.8497 17.9577 10.4563 17.5643C9.99367 17.1023 9.68167 16.9757 9.03434 16.9757C8.50701 16.9757 7.75434 17.0783 7.33901 16.6663C6.92101 16.2517 7.02367 15.4957 7.02367 14.965C7.02367 14.2937 6.87701 13.985 6.39901 13.5077C5.68834 12.797 5.33301 12.441 5.33301 11.9997C5.33301 11.5583 5.68834 11.2023 6.39967 10.4917C6.82634 10.065 7.02367 9.64234 7.02367 9.03434C7.02367 8.50701 6.92101 7.75434 7.33301 7.33901C7.74767 6.92101 8.50367 7.02367 9.03434 7.02367C9.64234 7.02367 10.065 6.82567 10.4917 6.39901C11.2023 5.68834 11.5583 5.33301 11.9997 5.33301C12.441 5.33301 12.797 5.68834 13.5077 6.39967C13.9343 6.82634 14.357 7.02367 14.965 7.02367C15.4923 7.02367 16.245 6.92101 16.6603 7.33301C17.0783 7.74767 16.9757 8.50367 16.9757 9.03434C16.9757 9.70567 17.1223 10.0143 17.6003 10.4917C18.311 11.2023 18.6663 11.5583 18.6663 11.9997C18.6663 12.441 18.311 12.797 17.5997 13.5077C17.1223 13.9857 16.9757 14.2943 16.9757 14.965C16.9757 15.4957 17.0777 16.2517 16.6597 16.6663Z"
            fill="white"
          />
          <path
            fill="none"
            d="M10 12.595C10 12.595 10.8 13.0297 11.2 13.6663C11.2 13.6663 12.4 11.1663 14 10.333"
            stroke="#D4AF37"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case CROSS:
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L12 12M12 12L6 18M12 12L18 18M12 12L6 6"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case SLICKRIGHT:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" version="1.1">
          <path
            d="M18.9002 12L4.5 12"
            stroke="#1A1B2F"
            strokeWidth="2"
            strokeLinecap="square"
          ></path>
          <path
            d="M13.4502 5.97541L19.5002 11.9994L13.4502 18.0244"
            stroke="#1A1B2F"
            strokeWidth="2"
            strokeLinecap="square"
          ></path>
        </svg>
      );
    case SLICKLEFT:
      return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M5.09976 12L19.5 12" stroke="#1A1B2F" strokeWidth="2" strokeLinecap="square" />
          <path
            d="M10.5498 5.97541L4.4998 11.9994L10.5498 18.0244"
            stroke="#1A1B2F"
            strokeWidth="2"
            strokeLinecap="square"
          />
        </svg>
      );
    case FACEBOOK:
      return (
        <svg
          width="22"
          height="30"
          viewBox="0 0 22 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.39366 9.0745C5.39366 4.37298 9.42841 0.666504 14.2723 0.666504H18.7577C19.1037 0.666504 19.4461 0.682218 19.7558 0.746C20.0734 0.811419 20.4237 0.940668 20.7191 1.21789C21.3008 1.76398 21.3337 2.56956 21.3337 3.1465V6.11184C21.3337 6.68878 21.3008 7.49436 20.7191 8.04045C20.4237 8.31767 20.0734 8.44692 19.7558 8.51234C19.4461 8.57612 19.1037 8.59184 18.7577 8.59184H14.2723C13.8977 8.59184 13.6977 8.86404 13.6977 9.0745V11.7772H16.911C17.3544 11.7772 17.778 11.7991 18.1451 11.8809C18.5117 11.9625 18.9446 12.1306 19.2582 12.5212C19.5801 12.9221 19.6419 13.388 19.6234 13.773C19.6054 14.148 19.5067 14.5527 19.3838 14.9571L18.7078 17.1787C18.5687 17.6362 18.3608 18.2075 17.8406 18.5764C17.3355 18.9346 16.7273 18.9625 16.2363 18.9625H13.6977V26.8518C13.6977 27.429 13.6647 28.2343 13.0836 28.7806C12.7885 29.0581 12.4382 29.1877 12.1203 29.2533C11.8104 29.3174 11.4679 29.3332 11.1217 29.3332H7.96966C7.62391 29.3332 7.28164 29.3175 6.97196 29.2536C6.65431 29.1881 6.30405 29.0588 6.00875 28.7816C5.42702 28.2355 5.39366 27.4301 5.39366 26.8518V18.9625H3.24299C2.89696 18.9625 2.55453 18.9468 2.24479 18.883C1.92707 18.8175 1.57666 18.6881 1.28132 18.4107C0.699799 17.8644 0.666992 17.0586 0.666992 16.4812V14.2585C0.666992 13.6813 0.699935 12.8761 1.28104 12.3298C1.57618 12.0523 1.92643 11.9227 2.24432 11.857C2.5542 11.793 2.89676 11.7772 3.24299 11.7772H5.39366V9.0745ZM14.2723 2.6665C10.4149 2.6665 7.39366 5.59203 7.39366 9.0745V12.7772C7.39366 13.3295 6.94594 13.7772 6.39366 13.7772H3.24299C2.97364 13.7772 2.80153 13.7897 2.69062 13.808C2.67712 13.8997 2.66699 14.0412 2.66699 14.2585V16.4812C2.66699 16.6985 2.67709 16.8401 2.69057 16.9319C2.80162 16.95 2.97375 16.9625 3.24299 16.9625H6.39366C6.94594 16.9625 7.39366 17.4102 7.39366 17.9625V26.8518C7.39366 27.0692 7.40383 27.2108 7.41736 27.3025C7.52831 27.3207 7.70038 27.3332 7.96966 27.3332H11.1217C11.391 27.3332 11.5631 27.3206 11.674 27.3024C11.6875 27.2107 11.6977 27.0692 11.6977 26.8518V17.9625C11.6977 17.4102 12.1454 16.9625 12.6977 16.9625H16.2363C16.4619 16.9625 16.5918 16.9514 16.6696 16.9371C16.6988 16.8787 16.7396 16.7767 16.7942 16.597L17.4702 14.3759C17.5468 14.1234 17.5894 13.9426 17.6101 13.8147C17.4577 13.7918 17.2345 13.7772 16.911 13.7772H12.6977C12.1454 13.7772 11.6977 13.3295 11.6977 12.7772V9.0745C11.6977 7.64764 12.9083 6.59184 14.2723 6.59184H18.7577C19.0269 6.59184 19.1991 6.57935 19.3102 6.56119C19.3236 6.4696 19.3337 6.32843 19.3337 6.11184V3.1465C19.3337 2.92991 19.3236 2.78874 19.3102 2.69715C19.1991 2.67899 19.0269 2.6665 18.7577 2.6665H14.2723Z"
            fill="#D4AF37"
          />
        </svg>
      );
    case INSTAGRAM:
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.141 10.3206C14.3234 9.70707 15.6692 9.482 16.9869 9.6774C18.3311 9.87672 19.5755 10.503 20.5363 11.4639C21.4971 12.4247 22.1235 13.6691 22.3228 15.0132C22.5182 16.331 22.2931 17.6767 21.6796 18.8592C21.066 20.0416 20.0953 21.0005 18.9054 21.5994C17.7154 22.1983 16.367 22.4068 15.0518 22.1951C13.7366 21.9835 12.5216 21.3625 11.5796 20.4206C10.6376 19.4786 10.0167 18.2636 9.80505 16.9484C9.59342 15.6332 9.80188 14.2847 10.4008 13.0948C10.9997 11.9049 11.9586 10.9342 13.141 10.3206ZM16.6936 11.6558C15.792 11.5221 14.8712 11.6761 14.0621 12.0959C13.2531 12.5157 12.597 13.1799 12.1873 13.994C11.7775 14.8082 11.6348 15.7308 11.7797 16.6307C11.9245 17.5305 12.3493 18.3619 12.9938 19.0064C13.6383 19.6509 14.4696 20.0757 15.3695 20.2205C16.2694 20.3653 17.192 20.2227 18.0062 19.8129C18.8203 19.4031 19.4845 18.7471 19.9043 17.938C20.3241 17.129 20.4781 16.2082 20.3444 15.3066C20.208 14.3869 19.7795 13.5355 19.1221 12.8781C18.4647 12.2207 17.6132 11.7921 16.6936 11.6558Z"
            fill="#D4AF37"
          />
          <path
            d="M23.333 7.6665C22.7807 7.6665 22.333 8.11422 22.333 8.6665C22.333 9.21879 22.7807 9.6665 23.333 9.6665H23.3463C23.8986 9.6665 24.3463 9.21879 24.3463 8.6665C24.3463 8.11422 23.8986 7.6665 23.3463 7.6665H23.333Z"
            fill="#D4AF37"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.66699 9.33317C1.66699 5.09899 5.09948 1.6665 9.33366 1.6665H22.667C26.9012 1.6665 30.3337 5.09899 30.3337 9.33317V22.6665C30.3337 26.9007 26.9012 30.3332 22.667 30.3332H9.33366C5.09948 30.3332 1.66699 26.9007 1.66699 22.6665V9.33317ZM9.33366 3.6665C6.20405 3.6665 3.66699 6.20356 3.66699 9.33317V22.6665C3.66699 25.7961 6.20405 28.3332 9.33366 28.3332H22.667C25.7966 28.3332 28.3337 25.7961 28.3337 22.6665V9.33317C28.3337 6.20356 25.7966 3.6665 22.667 3.6665H9.33366Z"
            fill="#D4AF37"
          />
        </svg>
      );
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

export default BrandIconCard;
